import React from "react";
import { Avatar, Button, Dropdown, message } from "antd";
import { DownOutlined, MoonOutlined, SunOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/actions/auth";
import { sleep } from "../../utils/utils";
import { useTheme } from "../../context/ThemeContext";

const HeaderActions = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();

  const onLogoutRequest = () => {
    dispatch(logout())
      .then((response) => {
        message.success(response?.message ?? "Logged out successfully");
        sleep(1000).then(() => navigate("/"));
      })
      .catch((err) => message.error(err));
  };

  const menu = {
    selectable: true,
    items: [
      {
        key: "logout",
        label: (
          <Button type="text" onClick={onLogoutRequest}>
            Logout
          </Button>
        ),
      },
    ],
  };

  return (
    <div className="sapa-header__profile">
      <Button
        aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
        className="sapa-header__themeButton"
        icon={theme === "dark" ? <SunOutlined /> : <MoonOutlined />}
        type="text"
        onClick={toggleTheme}
      />
      <Avatar className="sapa-header__profile_name">AA</Avatar>
      <Dropdown menu={menu}>
        <button className="ant-dropdown-link" type="button">
          <DownOutlined />
        </button>
      </Dropdown>
    </div>
  );
};

export default HeaderActions;
